import React, { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import LeagueManagementSidebar from "./Sidebar";
import { Col, Container, Navbar, Row } from "react-bootstrap";
import "../../assets/css/majorybl/pages/leaguemanagement.scss";
import { isXOrSmaller, scrollToTop } from "../../lib/utils";
import useBreakpoint from "../../hooks/useBreakpoint";

const LeagueManagementLayout = (): React.JSX.Element => {
    const location = useLocation();
    const pathMatch = /playoffs/.test(location.pathname);
    const [navBarCollapsed, setNavBarCollapsed] = useState(false);
    const breakpoint = useBreakpoint();
    useEffect(() => {
        scrollToTop();
        setNavBarCollapsed(true);
    }, [location.pathname]);

    const toggleNavbar = () => {
        pathMatch
            ? isXOrSmaller("lg", breakpoint) &&
              setNavBarCollapsed(!navBarCollapsed)
            : isXOrSmaller("md", breakpoint) &&
              setNavBarCollapsed(!navBarCollapsed);
    };

    const isRegistrationsPage = /league-registrations\/?$/.test(
        location.pathname,
    );

    return (
        <Container
            className="py-1 py-lg-5 leagueManagement"
            data-testid="leagueManagementContent"
        >
            {isRegistrationsPage ? (
                <>
                    <Row>
                        <Col>
                            <Navbar
                                expand="lg"
                                expanded={!navBarCollapsed}
                                className="horizontal"
                            >
                                <Navbar.Toggle
                                    aria-controls="basic-navbar-nav"
                                    onClick={toggleNavbar}
                                />
                                {isXOrSmaller("md", breakpoint) && (
                                    <Navbar.Text>
                                        <h4>Menu</h4>
                                    </Navbar.Text>
                                )}
                                <Navbar.Collapse>
                                    <LeagueManagementSidebar
                                        breakpoint={breakpoint}
                                        toggleNavbar={toggleNavbar}
                                        horizontal={true}
                                    />
                                </Navbar.Collapse>
                            </Navbar>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Outlet />
                        </Col>
                    </Row>
                </>
            ) : (
                <Row>
                    <Col lg={pathMatch ? undefined : 3} xl={2}>
                        <Navbar
                            expand={pathMatch ? "xl" : "lg"}
                            expanded={!navBarCollapsed}
                        >
                            <Navbar.Toggle
                                aria-controls="basic-navbar-nav"
                                onClick={toggleNavbar}
                            />
                            {isXOrSmaller(
                                pathMatch ? "lg" : "md",
                                breakpoint,
                            ) && (
                                <Navbar.Text>
                                    <h4>Menu</h4>
                                </Navbar.Text>
                            )}
                            <Navbar.Collapse>
                                <LeagueManagementSidebar
                                    breakpoint={breakpoint}
                                    toggleNavbar={toggleNavbar}
                                />
                            </Navbar.Collapse>
                        </Navbar>
                    </Col>
                    <Col lg={pathMatch ? undefined : 9} xl={10}>
                        <Outlet />
                    </Col>
                </Row>
            )}
        </Container>
    );
};

export default LeagueManagementLayout;
